import { forwardRef, type Ref, type SVGProps } from "react";
const IconBankOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M17.137 15.745c2.705.58 3.863 1.57 3.863 3.318 0 2.339-2.126 3.358-4.263 3.558V23c0 .552-.471.999-1.053.999-.581 0-1.052-.447-1.052-1v-.429c-1.528-.077-2.885-.95-3.527-2.269a1.3 1.3 0 0 1-.105-.49c0-.529.421-.849 1.053-.849.463-.027.89.237 1.052.65.761 1.066 2.085 1.64 3.432 1.489 1.463-.08 2.337-.82 2.337-1.759 0-.94-.632-1.439-2.327-1.829l-1.694-.36c-2.548-.54-3.737-1.538-3.737-3.317s1.379-3.048 3.568-3.398v-.44c0-.552.472-.999 1.053-.999s1.053.447 1.053 1v.39c1.936.209 3.378 1.098 3.81 2.387.056.158.085.324.084.49 0 .45-.368.74-.958.74a1.15 1.15 0 0 1-1.052-.64c-.679-1.014-1.898-1.581-3.158-1.469-1.316.13-2.221.82-2.221 1.699s.62 1.429 2.105 1.789z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m16.7 4.12 11.5 3.355a2.5 2.5 0 0 1 1.8 2.4V11.5a2.5 2.5 0 0 1-2 2.45v7.1a2.5 2.5 0 0 1 2 2.45v2a2.5 2.5 0 0 1-2.5 2.5h-23A2.5 2.5 0 0 1 2 25.5v-2a2.5 2.5 0 0 1 2-2.45v-7.1a2.5 2.5 0 0 1-2-2.45V9.875a2.5 2.5 0 0 1 1.8-2.4l11.5-3.354a2.5 2.5 0 0 1 1.4 0zm10.94 5.275-11.5-3.354a.5.5 0 0 0-.28 0L4.36 9.395a.5.5 0 0 0-.36.48V11.5a.5.5 0 0 0 .5.5H6v11H4.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h23a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5H26V12h1.5a.5.5 0 0 0 .5-.5V9.875a.5.5 0 0 0-.36-.48"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconBankOutlineSVG);
ForwardRef.displayName = "IconBankOutline";
export { ForwardRef as IconBankOutline };
